import React from 'react';
import TopLanding from '../../shared/components/TopLanding';

function Packages() {
    return (
        <div>
            <TopLanding />
        </div>
    )
}

export default Packages;
